module.exports = __webpack_public_path__ + "img/543-42dfb3.png";